// This file was automatically generated from app.shared.userHeadlines.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.userHeadlines');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.userHeadlines.wrapper = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="headlineAlertContainer"><div class="headlineTextContainer headline-contents"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.userHeadlines.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="user-headlines-content"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.userHeadlines.entry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(opt_data.hline.message, (opt_data.total > 1) ? '<div class="headlineCounterWrap">' + ((opt_data.index > 0) ? '<a class="prev-trigger headlinePrevButton" data-index="' + soy.$$escapeHtml(opt_data.index) + '" data-id="' + soy.$$escapeHtml(opt_data.hline.id) + '"></a>' : '') + '<span class="headlineCounter"> ' + soy.$$escapeHtml(opt_data.index + 1) + ' of ' + soy.$$escapeHtml(opt_data.total) + ' </span>' + ((opt_data.index < opt_data.total - 1) ? '<a class="next-trigger headlineNextButton" data-index="' + soy.$$escapeHtml(opt_data.index) + '" data-id="' + soy.$$escapeHtml(opt_data.hline.id) + '"></a>' : '') + '</div>' : '', '<a class="dismiss-trigger headlineDismiss"><span class="el8StandardFontSize el8NormalText padr3">Dismiss</span> &times;</a>');
  if (!opt_sb) return output.toString();
};
